import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { routeTree } from "./app/routes/routeTree.gen";
import { ErrorDialogProvider } from "./shared/components/ErrorDialog";
import { PwaUpdatePrompt } from "./shared/components/PwaUpdatePrompt";
import {
  RouteErrorFallback,
  RoutePendingFallback,
} from "./shared/components/RouterFallback";
import "./shared/lib/fonts";
import { queryClient } from "./shared/lib/queryClient";
import {
  persistQueryCache,
  restoreQueryCache,
} from "./shared/lib/queryPersist";
import "./styles.css";

// Restore any persisted query cache before the first render, then keep it in sync.
restoreQueryCache(queryClient);
persistQueryCache(queryClient);

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultErrorComponent: RouteErrorFallback,
  defaultPendingComponent: RoutePendingFallback,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element #root not found");

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorDialogProvider>
        <RouterProvider router={router} />
        <PwaUpdatePrompt />
      </ErrorDialogProvider>
    </QueryClientProvider>
  </StrictMode>,
);
